import React from 'react';
import { Row, Col } from 'react-bootstrap';
import LimitPreferenceRow from './LimitPreferenceRow';
// import label from '../../utils/lngEn';
// import config from '../../config';

class ManageRulesPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showConfModal: false,
      limitPreferenceModalValues: {
        title: '',
        gsId: '',
        initialValues: {
          is_time_conflict: false
        }
      }
    }
  }


  // Edit limitPreference Modal
    render() {
    // This const binding means we need to getCourseLocations by course.id, not by course
    const { limit_preferences, editLimitPreferenceModal, openDeleteModel } = this.props;

    return (
      <div>
        <Col md={12}>
          <div className="page-subtitle mt-4">Rules (optional)</div>
          <button type="button" className="btn btn-ter mb-4" onClick={() => { editLimitPreferenceModal() }}>
            Add Rule
          </button>
          <br />
          {limit_preferences && limit_preferences.length > 0 ? (
            <Row>
              <Col md={12}>
                <div>
                  {limit_preferences
                    .map((limitPreference, index) => {
                      return (
                        <LimitPreferenceRow
                          key={index}
                          limitPreference={limitPreference}
                          onDelete={openDeleteModel}
                          handleEdit={editLimitPreferenceModal}
                          courses={this.props.courses}
                        />
                      );
                    })}
                </div>
              </Col>
            </Row>
          ) : null}
        </Col>
      </div>
    );
  }
}

export default ManageRulesPage;




// WEBPACK FOOTER //
// ./src/components/rank/ManageRulesPage.js